export enum SocialType {
    FACEBOOK = 'facebook',
    INSTAGRAM = 'instagram',
    YOUTUBE = 'youtube',
    TWITTER = 'twitter',
    LINKEDIN = 'linkedin',
    WECHAT = 'wechat'
}
